'use client';

import scrollTo from '@src/utils/scrollTo';
import { ButtonScrollToPropsType } from './ButtonScrollTo.types';
export default function ButtonScrollTo({
  children,
  href
}: ButtonScrollToPropsType) {
  return <button onClick={scrollTo({
    target: `${href}`,
    offsetY: 140
  })} className='text-left font-[400] text-primary underline hover:text-primary--v2' data-sentry-component="ButtonScrollTo" data-sentry-source-file="ButtonScrollTo.tsx">
      {children}
    </button>;
}